<template>
  <div>
    <header>
      <div id="hContent">
        <h1 id="title">CHOOSE COMPUTER</h1>
        <h2 id="subtitle">
          An easy-to-use tool to choose the right computer based on your
          specific needs
        </h2>
      </div>
    </header>

    <div id="content">
      <div id="welcomeDiv">
        <strong id="welcomeTitle">Welcome!</strong>
        <p id="welcomeContent">
          Choose.Computer’s purpose is to help you find the best computer
          specifically for you. We offer a set of tools and content to help you
          take the best decision. This way, you’ll end up buying a PC which
          won’t fail you.
        </p>
      </div>

      <!-- Mobile -->
      <div class="d-lg-none">
        <b-card
          title="PC Chooser"
          img-src="https://images.unsplash.com/photo-1525547719571-a2d4ac8945e2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=700&q=80"
          img-alt="Image"
          img-top
          class="sectionCard shadow"
        >
          <div class="cardContent">
            <b-card-text>
              Our easy-to-use online tool to help you choose the best PC based
              on your specific needs. All you have to do is fill out a form and
              we’ll pick the best options for you!
            </b-card-text>

            <b-button class="cardButton" to="pc-chooser" variant="primary">
              Try it out!
            </b-button>
          </div>
        </b-card>

        <b-card
          title="Blog"
          img-src="https://images.unsplash.com/photo-1547419543-db0732b9dd06?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=700&q=80"
          img-alt="Image"
          img-top
          class="sectionCard shadow"
        >
          <div class="cardContent">
            <b-card-text>
              Want to learn more about how to choose a computer or how do they
              work? Take a look at our blog!
            </b-card-text>

            <b-button
              class="cardButton"
              href="https://medium.com/robot-thoughts"
              variant="primary"
            >
              Learn more
            </b-button>
          </div>
        </b-card>
      </div>

      <!-- Bigger than mobile -->
      <div class="d-none d-md-block">
        <b-card
          title="PC Chooser"
          img-src="https://images.unsplash.com/photo-1525547719571-a2d4ac8945e2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=700&q=80"
          img-alt="Image"
          img-left
          img-width="300vw"
          class="sectionCard shadow"
        >
          <div class="cardContent">
            <b-card-text>
              Our easy-to-use online tool to help you choose the best PC based
              on your specific needs. All you have to do is fill out a form and
              we’ll pick the best options for you!
            </b-card-text>

            <b-button class="cardButton" to="pc-chooser" variant="primary">
              Try it out!
            </b-button>
          </div>
        </b-card>

        <b-card
          title="Blog"
          img-src="https://images.unsplash.com/photo-1547419543-db0732b9dd06?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=700&q=80"
          img-alt="Image"
          img-right
          img-width="300vw"
          class="sectionCard shadow"
        >
          <div class="cardContent">
            <b-card-text>
              Want to learn more about how to choose a computer or how do they
              work? Take a look at our blog!
            </b-card-text>

            <b-button
              class="cardButton"
              href="https://medium.com/robot-thoughts"
              variant="primary"
            >
              Learn more
            </b-button>
          </div>
        </b-card>
      </div>
    </div>

    <footer>
      <div id="footerContent">CHOOSE.COMPUTER</div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Home",
  metaInfo: {
    title: "Home",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Our easy-to-use online tool to help you choose the best PC based on your specific needs. All you have to do is fill out a form and we'll pick the best options for you!",
      },
    ],
  },
};
</script>

<style scoped>
header {
  background-image: url("../assets/macbookHeader.jpeg");
  background-size: 300%;
  background-repeat: no-repeat;
  background-position: center top;
  background-attachment: fixed;
}

footer {
  background-color: rgb(39, 39, 39);
  height: 10vh;
}

body {
  background-color: rgb(226, 226, 226);
}

#footerContent {
  padding-top: 2.5vh;
  color: white;
  text-align: center;
}

#hContent {
  text-align: center;
  color: white;
  background-color: rgba(0, 0, 0, 0.493);
  min-height: 70vh;
  padding-right: 10vw;
  padding-left: 10vw;
}

#title {
  padding-top: 25vh;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-weight: 800;
}

#subtitle {
  margin-top: 3vh;
  font-size: 1.1rem;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
}

#welcomeDiv {
  margin-right: auto;
  margin-left: auto;
  padding-top: 7vh;
  text-align: center;
  font-size: 1.5rem;
  padding-left: 10vw;
  padding-right: 10vw;
  margin-bottom: 10vh;
}

#welcomeTitle {
  font-weight: 800;
  font-family: fantasy;
}

#welcomeContent {
  margin-top: 4vh;
}

.sectionCard {
  margin-left: 7vw;
  margin-right: 7vw;
  margin-top: 5vh;
  margin-bottom: 10vh;
}

.cardContent {
  font-size: 1.2rem;
}

.cardButton {
  font-size: 1.2rem;
}

@media screen and (min-width: 600px) {
  header {
    background-size: cover;
  }

  #hContent {
    padding-top: 14vh;
    min-height: 100vh;
  }

  .sectionCard {
    margin-left: auto;
    margin-right: auto;
    max-width: 65vw;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue